import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { WhyChooseUsList } from "@/components/whyChooseUs/WhyChooseUsList";

export default function WhyChooseUs() {
  return (
    <>
      <Seo
        title="Why Choose Us"
        description="Why choose RKG NATURALS for your import, export and wholesale trade needs."
        path="/why-choose-us"
      />
      <div data-testid="why-choose-us-page">
        <PageHero eyebrow="Why Choose Us" title="Why Choose Us" />
        <WhyChooseUsList />
      </div>
    </>
  );
}
